import { useCallback, useEffect, useMemo, useState } from "react"

type State<T> = T | null
type SetStateFunc<T> = (newState: State<T>) => void
type ClearStateFunc = () => void

const usePersistedState = (
  key: string
): [State<string>, SetStateFunc<string>, ClearStateFunc] => {
  const [state, setState] = useState<State<string>>(null)

  const setAndSaveState = useCallback(
    (newState: State<string>) => {
      if (newState) window.localStorage.setItem(key, newState)
      else window.localStorage.removeItem(key)

      setState(newState)
    },
    [key]
  )

  const clearPersistedState = useCallback(
    () => window.localStorage.removeItem(key),
    [key]
  )

  useEffect(() => {
    setState(window.localStorage.getItem(key))
  }, [key])

  return useMemo(
    () => [state, setAndSaveState, clearPersistedState],
    [state, setAndSaveState, clearPersistedState]
  )
}

export default usePersistedState
